import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import BrianyCareLogo from "../../assets/auth/BrainyCare-Logo.jpg";
import dayjs from "dayjs";
import {data}from '../data'
const AbdominalUltrasoundDopplerview = () => {
  const { filename } = useParams();
  const [examData, setExamData] = useState(null);

  useEffect(() => {
    const fetchExamData = async () => {
      try {
   const response = await axios.post(
        `/v2/ag/v1/${window.getPracticeId()}/imaging/get-image/id`,
        { row_id: parseInt(filename, 10) }
      );
      
      if (response?.data?.data[0]) {
        const raw = response.data?.data[0];
        const parsedData = JSON.parse(raw.data);
        setExamData(parsedData);
      }
      } catch (error) {
        console.error("Error fetching exam data:", error);
      }
    };

    fetchExamData();
  }, [filename]);

  return (
<div
  id={examData ? "report-ready" : undefined}
  className="p-6 bg-white min-h-screen w-full flex justify-center items-center"
>
  <div className="w-full max-w-3xl border border-gray-300 rounded-md p-10 shadow-sm text-sm">
        {/* Header */}
        <div className="flex items-start w-full justify-center">
          <img
            src={BrianyCareLogo}
            alt="C-HIM Logo"
            className="w-14 h-14 mr-3"
          />
          <div>
            <h1 className="text-xl text-start font-bold text-blue-600 leading-none">
              C-HIM
            </h1>
            <p className="text-sm font-semibold mt-1">
              Center for Hypertension & Internal Medicine
            </p>
          </div>
        </div>

        {/* Title */}
        <h2 className="text-center font-bold text-base underline mb-6">
          ABDOMINAL ULTRASOUND DOPPLER
        </h2>

        {examData ? (
          <>
           <div className="flex justify-start text-sm text-left w-full mb-4">
                      <div className="grid grid-cols-[auto_20px_1fr] gap-x-2 gap-y-1">
                        <span><strong>MR No#</strong></span>
                        <span>:</span>
                        <span>{examData.patientid}</span>
                    
                        <span><strong>Name</strong></span>
                        <span>:</span>
                        <span>{examData.pat_name}</span>
                    
                        <span><strong>Age</strong></span>
                        <span>:</span>
                        <span>{examData.age}</span>
                    
                        <span><strong>Exam Date</strong></span>
                        <span>:</span>
                        <span>{dayjs(examData.examDate).format("MM, DD, YYYY")}</span>
                    
                        <span><strong>Date of Birth</strong></span>
                        <span>:</span>
                        <span>{dayjs(examData.pat_dob).format("MMM D, YYYY")}</span>
                    
                        <span><strong>Provider</strong></span>
                        <span>:</span>
                        <span>{examData.providername}</span>
                    
                        
                    
                        <span><strong>Patients History</strong></span>
                        <span>:</span>
                        <span>{examData.history}</span>
                      </div>
                    </div>
      
        {/* Doppler Fields */}
<div className="w-full flex justify-center mb-6">
  <div className="space-y-4 w-full  text-start">
    <div className="flex gap-4">
      <strong className="min-w-[180px]">Liver :</strong>
      <span>{examData.liverComment}</span>
    </div>

    <div className="flex gap-4">
      <strong className="min-w-[180px]">Main Portal Vein :</strong>
      <span>{examData.mainPortalVeinComment}</span>
    </div>

    <div className="flex gap-4 flex-wrap">
      <strong>Rt :</strong> <span>{examData.hepaticVeinsRt}</span>
      <strong>Mid :</strong> <span>{examData.hepaticVeinsMid}</span>
      <strong>Lt :</strong> <span>{examData.hepaticVeinsLt}</span>
    </div>

    <div className="flex gap-4">
      <strong className="min-w-[180px]">Hepatic Veins :</strong>
      <span>{examData.hepaticVeinsComment}</span>
    </div>

    <div className="flex gap-4">
      <strong className="min-w-[180px]">HEPATIC ARTERY :</strong>
      <span>{examData.hepaticArtery}</span>
    </div>

    <div className="flex gap-4">
      <strong className="min-w-[180px]">SPLEEN :</strong>
      <span>{examData.spleen}</span>
    </div>

    <div className="flex gap-4">
      <strong className="min-w-[180px]">SPLENIC VEIN :</strong>
      <span>{examData.splenicVein}</span>
    </div>

    {/* ASCITES */}
    <div className="flex gap-4 items-center">
      <strong className="min-w-[180px]">ASCITES :</strong>
      <label className="flex items-center gap-1">
        <input type="radio" checked={examData.ascites === 'Yes'} readOnly /> Yes
      </label>
      <label className="flex items-center gap-1">
        <input type="radio" checked={examData.ascites === 'No'} readOnly /> No
      </label>
    </div>

    <div className="flex gap-4">
      <strong className="min-w-[180px]">Ascites Comments :</strong>
      <span>{examData.ascitesComment}</span>
    </div>

    {/* VARICES */}
    <div className="flex gap-4 items-center">
      <strong className="min-w-[180px]">VARICES :</strong>
      <label className="flex items-center gap-1">
        <input type="radio" checked={examData.varices === 'Yes'} readOnly /> Yes
      </label>
      <label className="flex items-center gap-1">
        <input type="radio" checked={examData.varices === 'No'} readOnly /> No
      </label>
    </div>

    <div className="flex gap-4">
      <strong className="min-w-[180px]">Varices Comments :</strong>
      <span>{examData.varicesComment}</span>
    </div>

    {/* HEPATOPEDAL FLOW */}
    <div className="flex gap-4 items-center">
      <strong className="min-w-[180px]">HEPATOPEDAL FLOW :</strong>
      <label className="flex items-center gap-1">
        <input type="radio" checked={examData.hepatopedal === 'Yes'} readOnly /> Yes
      </label>
      <label className="flex items-center gap-1">
        <input type="radio" checked={examData.hepatopedal === 'No'} readOnly /> No
      </label>
    </div>

    {/* HEPATOFUGAL FLOW */}
    <div className="flex gap-4 items-center">
      <strong className="min-w-[180px]">HEPATOFUGAL FLOW :</strong>
      <label className="flex items-center gap-1">
        <input type="radio" checked={examData.hepatofugal === 'Yes'} readOnly /> Yes
      </label>
      <label className="flex items-center gap-1">
        <input type="radio" checked={examData.hepatofugal === 'No'} readOnly /> No
      </label>
    </div>

    <div className="flex gap-4">
      <strong className="min-w-[180px]">Hepafugal Flow Comments :</strong>
      <span>{examData.hepatofugalComment}</span>
    </div>

    {/* Impression */}
    <div className="flex gap-4">
      <strong className="min-w-[180px]">Sonographers Impression :</strong>
      <span>{examData.impression}</span>
    </div>
  </div>
</div>


           <div className="flex justify-end w-full">
  <div className="relative flex items-stretch border p-2 min-w-[350px] max-w-full">
    
    {/* Signature - grows with content */}
    <div className="font-semibold pr-4 z-10 break-words whitespace-pre-wrap max-w-[50%]">
      {examData.signature}
    </div>

    {/* Divider */}
    <div className="absolute top-0 bottom-0 left-1/2 w-px bg-gray-300" />

    {/* Right section - always left aligned */}
    <div className="text-sm text-left z-10 pl-4 w-1/2">
      <div>Digitally Signed by</div>
     <div>{examData?.createdby||''}</div>
         <div>{dayjs(examData.dateofservice).format("MM-DD-YYYY")}</div>
    </div>
  </div>
</div>
          </>
        ) : (
          <p className="text-center text-gray-500">Loading...</p>
        )}
      </div>
    </div>
  );
};

export default AbdominalUltrasoundDopplerview;
